import { createBrowserHistory } from 'history'
import * as Sentry from '@sentry/react'

const history = createBrowserHistory()

let initialized = false
export default (config, user) => {
  const { sentryDsn } = config
  if (!(process.env.NODE_ENV === 'production' && sentryDsn)) {
    return
  }

  Sentry.init({
    dsn: sentryDsn,
    sendDefaultPii: true,
    integrations: [
      Sentry.reactRouterV5BrowserTracingIntegration({
        history
      }),
      Sentry.replayIntegration({
        maskAllText: false,
        maskAllInputs: true,
        blockAllMedia: false
      })
    ],
    tracesSampleRate: 0.25,
    // Capture Replay for 10% of all sessions,
    // plus for 100% of sessions with an error
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    release: 'field-supply@' + process.env.REACT_APP_BUILD_VERSION
  })

  if (user) {
    Sentry.setUser({username: user.name})
  }

  initialized = true
}

export const setUserInSentry = (user) => {
  if (user) {
    Sentry.setUser({username: user.name})
  }
}

export const logError = (error, extraInfo) => {
  if (initialized) {
    Sentry.withScope(scope => {
      scope.setExtras(extraInfo)
      Sentry.captureException(error)
    })
  }
}
